jQuery(($) => {
	$(".accord:has(div ul li.active)").addClass("active");

	$(".accord .header, .accord .answer").on("click", function () {
		var $parent = $(this).closest(".accord");

		if ($parent.hasClass("active")) {
			$(".accord.active").removeClass("active");
			$parent.addClass("active");
			console.log("active");
		} else {
			$parent.removeClass("active");
			console.log("not-active");
		}
	});

	//remove active class when first time loading on mobile
	if ($(window).width() < 768) {
		$(".accord").removeClass("active");
	}
});
